import {ref} from "vue";

const TOAST_VARIANTS = {
  SUCCESS: 'success',
  INFO: 'info',
  WARNING: 'warning',
  ERROR: 'error',
};

const createToast = (text, title, status) => ({
  id: crypto.randomUUID(),
  text,
  title,
  status,
});

const addToast = (text, title = null, status = null, timeout = 4000) => {
  // Don't add a duplicate toast with the same status and text
  if (toasts.value.find((toast) => toast.text === text && toast.status === status)) {
    return;
  }

  status = status ?? TOAST_VARIANTS.SUCCESS;

  const newToast = createToast(
    text,
    title ?? status.toString().charAt(0).toUpperCase() + status.slice(1), // capitalize status
    status,
  );

  toasts.value = [...toasts.value, newToast];

  setTimeout(() => {
    dismissToast(newToast.id);
  }, timeout);
};

export const toasts = ref([]);

export const dismissToast = (uuid) => {
  toasts.value = toasts.value.filter((toast) => toast.id !== uuid);
};

export const successToast = (text, title) => {
  addToast(text, title, TOAST_VARIANTS.SUCCESS);
};

export const infoToast = (text, title) => {
  addToast(text, title, TOAST_VARIANTS.INFO);
};

export const warningToast = (text, title) => {
  addToast(text, title, TOAST_VARIANTS.WARNING);
};

export const errorToast = (text, title) => {
  addToast(text, title, TOAST_VARIANTS.ERROR);
};
